var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Catalogue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 14a8 8 0 00-6 2.72A8.001 8.001 0 0032 14H3v48h29a4 4 0 014 4h4a4 4 0 014-4h29V14H44zM32 58H7V18h25a4 4 0 014 4v37.08A7.91 7.91 0 0032 58zm37 0H43.88A7.9 7.9 0 0040 59.08V22a4 4 0 014-4h25v40zM44 37h21v4H44v-4zm0-8h21v4H44v-4zm0 16h10v4H44v-4zm-33-8h21v4H11v-4zm0-8h21v4H11v-4zm0 16h11v4H11v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Catalogue.1f84e10c.svg";
export { SvgJ2Catalogue as ReactComponent };